
    <a
      *ngIf="!isExternalLink(); else external"
      [ngClass]="
        hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'
      "
      routerLinkActive="active"
      [routerLink]="[link.url]"
      (click)="toggleOnMobile()"
    >
      <fa-icon
        *ngIf="isIcon()"
        [ngClass]="isActive() ? 'text-primary' : ''"
        [icon]="['fa', link.icon]"
      ></fa-icon>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{
        link.badge.text
      }}</span>
      <div *ngIf="link.hasBadge && badgeCount > 0" class="unread">
        <span>{{ badgeCount }}</span>
      </div>
    </a>
    <ng-template #external>
      <a
        [ngClass]="
          hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'
        "
        href="{{ link.url }}"
      >
        <fa-icon
          *ngIf="isIcon()"
          [ngClass]="isActive() ? 'text-primary' : ''"
          [icon]="['fa', link.icon]"
        ></fa-icon>
        {{ link.name }}
        <span
          *ngIf="isBadge()"
          [ngClass]="'badge badge-' + link.badge.variant"
          >{{ link.badge.text }}</span
        >
      </a>
    </ng-template>
  